import { render, staticRenderFns } from "./account-registration-complete.vue?vue&type=template&id=30a33632&"
import script from "./account-registration-complete.vue?vue&type=script&lang=ts&"
export * from "./account-registration-complete.vue?vue&type=script&lang=ts&"
import style0 from "./account-registration-complete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports